define('Search/SearchBox',["Search/Search", "instantsearch", "jquery", "Track/GoalsManager"],
    function (Search, instantsearch, $, goalsManager) {
        function SearchBox(searchBoxId, placeholderText, algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage, searchButtonId, searchResultsPageUrl) {
            var typingTimer;
            var doneTypingInterval = 1500;

            if (!Search.configured) {
                Search.defaultConfig(algoliaApplicationId, algoliaApiKey, algoliaIndexName, contextLanguage);
            }

            Search.addWidget(
                instantsearch.widgets.searchBox({
                    container: '#' + searchBoxId,
                    placeholder: placeholderText,
                    autofocus: true,
                    wrapInput: false
                })
            );

            $('#' + searchButtonId).on('click', function () {
                performSearch();
            });

            $('#' + searchBoxId).keypress(function (e) {
                if (e.which === 13) {
                    performSearch();
                }
            });

            $('#' + searchBoxId).keyup(function(e) {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
            });

            $('#' + searchBoxId).keydown(function(e) {
                clearTimeout(typingTimer);
            });

            function performSearch() {
                if ($(window).attr('location').href.indexOf(searchResultsPageUrl) === -1) {
                    var searchInput = $('#' + searchBoxId).val();
                    if (searchInput) {
                        var newUrl = searchResultsPageUrl + "?q=" + encodeURI(searchInput);
                        $(window).attr('location', newUrl);
                    }
                } else {
                    Search.search.helper.search();
                }
            }

            function doneTyping() {
                var searchInput = $('#' + searchBoxId).val();
                if (searchInput) {
                    goalsManager.triggerSiteSearch(searchInput);
                }
            }
        }

        return function InitSearchBox(args) {
            return new SearchBox(args.SearchBoxId,
                    args.PlaceholderText,                    
                    args.AlgoliaApplicationId,
                    args.AlgoliaApiKey,
                    args.AlgoliaIndexName,
                    args.ContextLanguage,
					args.SearchButtonId,
                    args.SearchResultsPageUrl);
        };
    });
